import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import * as fromConnectContacts from './reducers/connect-contacts.reducer';
import * as fromConnectData from './reducers/connect-data.reducer';

export const connectFeatureKey = 'connect';

export interface ConnectState {
  [fromConnectData.connectDataFeatureKey]: fromConnectData.DataState;
  [fromConnectContacts.connectContactsFeatureKey]: fromConnectContacts.ContactsState;
}

export interface State {
  [connectFeatureKey]: ConnectState;
}

export const initialState: ConnectState = {
  [fromConnectData.connectDataFeatureKey]: fromConnectData.dataInitialState,
  [fromConnectContacts.connectContactsFeatureKey]:
    fromConnectContacts.contactsInitialState,
};

export function reducers(state: ConnectState | undefined, action: Action) {
  return combineReducers({
    [fromConnectData.connectDataFeatureKey]: fromConnectData.dataReducer,
    [fromConnectContacts.connectContactsFeatureKey]:
      fromConnectContacts.contactsReducer,
  })(state, action);
}

export const selectConnectState =
  createFeatureSelector<ConnectState>(connectFeatureKey);
